enum ActionType {
    GET_CURRENT_USER = '[CORE/USER] GET CURRENT USER',
    REQUEST_CURRENT_USER = '[CORE/USER] REQUEST CURRENT USER',
    RECEIVE_CURRENT_USER = '[CORE/USER] RECEIVE CURRENT USER',
    SET_ROLES_FOR_CURRENT_USER = '[CORE/USER] SET ROLES FOR CURRENT USER',
}

export default ActionType
